import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IPagedResults } from 'src/app/core/models/base';
import { environment } from 'src/environments/environment';
import {
  IIgnoreWorkTimeViolationRequest,
  ISearchWorkTimeViolationsRequest,
  IWorkTimeViolation
} from '../models/work-time-violation';

@Injectable({
  providedIn: 'root'
})
export class WorkTimeViolationService {

  constructor(private http: HttpClient) { }

  searchWorkTimeViolations(request: ISearchWorkTimeViolationsRequest) {
    return this.http.post<IPagedResults<IWorkTimeViolation[]>>(
      `${environment.baseUrl}/v1/WorkTimeViolation/searchWorkTimeViolations`,
      request
    );
  }

  ignoreWorkTimeViolation(request: IIgnoreWorkTimeViolationRequest) {
    return this.http.put<string>(
      `${environment.baseUrl}/v1/WorkTimeViolation/ignoreWorkTimeViolation/${request.id}`,
      request
    );
  }

  /** Re-evaluates the violation's day right away and returns its new state (after a correction). */
  reevaluateWorkTimeViolation(id: string) {
    return this.http.put<IWorkTimeViolation>(
      `${environment.baseUrl}/v1/WorkTimeViolation/reevaluateWorkTimeViolation/${id}`,
      {}
    );
  }
}
